<template>
  <v-container fill-height grid-list-xl>
    <v-layout justify-center wrap>
      <section
        id="causeSectionHeader"
        style="position: relative; min-width: 100vw; top: -24px"
      >
        <v-img
          height="100%"
          position="center center"
          src="https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/appImages%2FRED%20Banner%20for%20web%20-%201920X300pxH%20(1).jpg?alt=media&token=b776a7b8-0537-40c4-92b9-c7b3e6264fa0"
          class="hidden-xs-only"
        />
        <v-img
          position="center center"
          src="https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/appImages%2FRed%20Banner%20for%20web%20-%20300pxH.jpg?alt=media&token=a6130918-d197-435c-871d-09556f4da0a6"
          class="hidden-sm-and-up"
        />
      </section>

      <v-container grid-list-xl class="pageContent">
        <v-layout row wrap align-center>
          <v-flex xs12 style="text-align: center">
            <h3
              style="
                font-weight: bold !important;
                font-family: 'Aleo' !important;
                font-size: 30pt !important;
                color: black;
              "
            >
              UpstreamNZ Christmas Impact Boxes
            </h3>
            <h5 class="christmasSubHeader mb-0">
              Thank you for your support! We are now out of Giftboxes.
            </h5>
            <!-- <h5 class="christmasSubHeader mt-0">
              Impact Boxes will be made up and delivered during the week of 7th
              - 12th Dec
            </h5> -->
          </v-flex>
          <!-- <v-flex xs12 style="text-align: left">
            <p>
              Here's an Impactful way to say thank you to your staff, clients or
              treat someone special. We have teamed up with Trade Aid to provide
              these unique Christmas Impact Boxes. Benefit from easy ordering,
              free shipping and 20% of your purchase goes towards the UpstreamNZ
              Foundation which exists to strengthen the wellbeing of children
              and young people.
            </p>
          </v-flex> -->
          <!-- <v-flex xs12 style="text-align: center">
            <h3
              style="
                font-weight: bold !important;
                font-family: 'Aleo' !important;
                font-size: 15pt !important;
                color: black;
              "
            >
              Bulk order for Christmas ? Multiple addresses needed : Save time
              and download our bulk order form -
              <v-btn
                :href="`https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/appImages%2FUpstreamNZ%20Impact%20Box%20_%20Bulk%20Order%20Form.xlsx?alt=media&token=c8af29b9-2318-4eb1-a247-ce0d79441cf3`"
                target="”_blank”"
                class="info text-capitalize"
              >
                Click Here
              </v-btn>
            </h3>
          </v-flex> -->
          <!-- <v-flex sm12> -->
          <!-- <v-form ref="impactBoxForm" style="max-width: 90%; margin: auto">
              <v-layout wrap>
                <v-flex xs12>
                  <h4
                    style="
                      font-family: 'Aleo' !important;
                      font-size: 20pt !important;
                      color: #4cc7e8;
                    "
                  >
                    Your Contact Details
                  </h4>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="formData.fullName"
                    :rules="[(v) => !!v || 'Full name is required']"
                    label="Full name*"
                  />
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="formData.phone"
                    :rules="[(v) => !!v || 'Phone number is required']"
                    label="Your phone number*"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="formData.email"
                    :rules="[(v) => !!v || 'Email is required']"
                    label="Your Email Address*"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-checkbox
                    v-model="formData.mailingList"
                    :label="`Keep me up to date on UpstreamNZ impact stories and other offers.`"
                  ></v-checkbox>
                </v-flex>

                <v-flex xs12>
                  <h4
                    style="
                      font-family: 'Aleo' !important;
                      font-size: 20pt !important;
                      color: #4cc7e8;
                    "
                  >
                    How many Christmas Impact Boxes would you like?
                  </h4>
                  <h5
                    style="
                      font-family: 'Aleo' !important;
                      font-size: 12pt !important;
                      color: black;
                    "
                  >
                    Whats Inside?
                  </h5>
                  <ul>
                    <li>
                      Local Ginger Beer ( using ethically imported Trade Aid
                      Sugar & Ginger )
                    </li>
                    <li>
                      Trade Aid Chocolate Dusted Almonds ( Cerftified Organic /
                      Fair Trade )
                    </li>
                    <li>
                      Trade Aid Milk Choc Bar ( Cerftified Organic / Fair Trade
                      )
                    </li>
                    <li>
                      Trade Aid Christmas Scroggin ( using ethically imported
                      Trade Aid Cashews & Almonds )
                    </li>
                    <li>Personalized Card with your message</li>
                  </ul>
                  <h5
                    style="
                      font-family: 'Aleo' !important;
                      font-size: 12pt !important;
                      color: black;
                    "
                  >
                    $30 per Impact Box ( Free delivery anywhere in NZ & GST is
                    inclusive )
                  </h5>
                </v-flex>
                <v-flex xs12>
                  <v-img
                    style="max-width: 600px; margin: auto"
                    src="https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/appImages%2FHero%20low%20res%20179KB.png?alt=media&token=aebd25f6-a59f-44d9-a06c-3df0fc94f560"
                  />
                </v-flex>

                <v-flex xs12>
                  <v-text-field
                    v-model="formData.quantity"
                    :rules="[
                      (v) => !!v || 'Quantity is required',
                      (v) => v > 0 || 'Quantity cannot be less than 1',
                    ]"
                    label="Quantity"
                    type="number"
                  />
                </v-flex>

                <v-flex xs12>
                  <h4
                    style="
                      font-family: 'Aleo' !important;
                      font-size: 20pt !important;
                      color: #4cc7e8;
                    "
                  >
                    Who are we sending this gift to?
                  </h4>
                </v-flex>

                <v-flex xs12>
                  <v-checkbox
                    v-model="formData.giftForSelf"
                    @change="giftForSelfClick()"
                    :label="`Is it for you?`"
                  ></v-checkbox>
                </v-flex>

                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="formData.toFullName"
                    :rules="[(v) => !!v || 'Full name is required']"
                    label="Full name*"
                  />
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="formData.building"
                    label="Company / Building / Appt # ( Optional )"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="formData.address"
                    :rules="[(v) => !!v || 'Address is required']"
                    label="Address*"
                  />
                </v-flex>

                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="formData.suburb"
                    :rules="[(v) => !!v || 'Suburb is required']"
                    label="Suburb*"
                  />
                </v-flex>

                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="formData.postCode"
                    :rules="[(v) => !!v || 'Post Code is required']"
                    label="Post Code*"
                  />
                </v-flex>

                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="formData.city"
                    :rules="[(v) => !!v || 'City is required']"
                    label="City*"
                  />
                </v-flex>

                <v-flex xs12>
                  <v-textarea
                    v-model="formData.giftMessage"
                    label="Your Gift Message"
                    counter="160"
                    maxlength="160"
                  ></v-textarea>
                </v-flex>

                <v-flex xs12>
                  <v-textarea
                    v-model="formData.specialRequests"
                    label="Special Requests (This will let our admin know any specific requests)"
                  ></v-textarea>
                </v-flex>

                <v-flex xs12>
                  <v-radio-group v-model="formData.alternatePayment" mandatory>
                    <v-radio
                      label="I will pay for this with my credit card now"
                      :value="false"
                    ></v-radio>
                    <v-radio
                      label="I want to be invoiced or pay bank deposit"
                      :value="true"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>

                <v-flex xs12>
                  <v-btn class="info" :loading="loading" @click="placeOrder()"
                    >Place Order</v-btn
                  >
                  <p v-if="!formData.alternatePayment">
                    You will be transported to our Stripe payment checkout
                  </p>
                  <p v-else>You will be Invoiced by UpstreamNZ</p>
                </v-flex>
              </v-layout>
            </v-form> -->
          <!-- </v-flex> -->
        </v-layout>
      </v-container>
    </v-layout>

    <!-- <v-dialog v-model="checkoutDialog" max-width="600px">
      <v-card>
        <v-card-title>UpstreamNZ Checkout</v-card-title>
        <v-card-text>
          <h3>{{ formData.quantity }} x Christmas Impact Boxes</h3>
          <h3>Your total is : ${{ formData.quantity * 30 }}</h3>
          <stripe-elements
            ref="checkoutForm"
            pk="pk_live_51GwfMuCdvCqlJd9GRPzADulbIwEAJL831fZeHQdRiC62JjEizgamQ2Oj0ylKvasjOcM9FcldzLt60GvMOokvh0gL00Ncm5pvWm"
            :amount="formData.quantity * 30"
            required
            :description="`ClickOrder for`"
            currency="NZD"
            @token="tokenCreated"
          ></stripe-elements>
        </v-card-text>
        <v-card-actions>
          <h3>We are using Stripe as our protection gateway</h3>
          <v-spacer></v-spacer>
          <v-btn :loading="paymentLoading" @click="checkout()" color="primary"
            >Pay Now</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </v-container>
</template>

<script>
  import { mapGetters } from "vuex";
  import { StripeElements } from "vue-stripe-checkout";

  export default {
    components: {
      StripeElements,
    },
    data: () => ({
      formData: {
        alternatePayment: false,
      },
      emailFormConfirmation: false,
      checkoutDialog: false,
      loading: false,
      paymentLoading: false,
      orderID: null,
    }),
    computed: {
      ...mapGetters({
        user: "user",
        userData: "user/userData",
      }),
    },
    methods: {
      giftForSelfClick() {
        if (this.formData.giftForSelf) {
          this.formData.toFullName = this.formData.fullName;
        } else {
          this.formData.toFullName = "";
        }
      },
      placeOrder() {
        if (this.$refs.impactBoxForm.validate()) {
          this.loading = true;
          this.$store
            .dispatch("stripe/submitForm", this.formData)
            .then((result) => {
              this.loading = false;
              if (result.result == "Success") {
                this.orderID = parseInt(result.orderID);
                if (this.formData.alternatePayment) {
                  this.$swal(
                    "Request Submitted",
                    "We will be incontact with you ASAP",
                    "success"
                  );
                } else {
                  this.checkoutDialog = true;
                }
              } else {
                this.$swal(
                  "Error",
                  "There was an error with this form unfortunately",
                  "error"
                );
              }
            });
        } else {
          this.$swal("Error", "Please fill out the Required Fields", "error");
        }
      },
      async tokenCreated(token) {
        let payload = {
          token: token,
          id: this.orderID,
        };
        this.$store.dispatch("stripe/makePayment", payload).then((result) => {
          this.paymentLoading = false;
          if (result.Result === "Successful") {
            this.$swal(
              "Payment  received!",
              "Thank you for your purchase!",
              "success"
            );
            this.checkoutDialog = false;
            this.$router.push("/");
          } else {
            this.$swal(
              "Payment unsuccessful",
              "Please check your details and try again. If you continue to have problems please contact your bank.",
              "error"
            );
          }
        });
      },
      checkout() {
        this.paymentLoading = true;
        this.$refs.checkoutForm.submit();
      },
    },
  };
</script>

<style scoped>
  .christmasSubHeader {
    color: red;
    font-family: "Aleo" !important;
    font-weight: bold;
  }
</style>
